import { render, staticRenderFns } from "./ArtworkNavigation.vue?vue&type=template&id=d3daba0c&"
import script from "./ArtworkNavigation.vue?vue&type=script&lang=js&"
export * from "./ArtworkNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports